/**
 * InlineSpinner — círculo giratorio pequeño para indicar acción en curso
 * dentro de botones u otros elementos inline.
 *
 * Introducido en Sprint 12 (polish) para dar feedback visual durante
 * cambios de estado del expediente, donde el `mutation.isPending` duraba
 * 1-2s sin señal y el usuario sentía el sistema "pegado".
 *
 * `tone` mapea al color del borde superior:
 * - `brand`: para botones primarios (transición forward).
 * - `slate`: para botones secundarios (revertir estado).
 * - `white`: para botones de fondo sólido (CTA emerald), donde los dos
 *   anteriores no tienen contraste suficiente.
 */
export type InlineSpinnerTone = "brand" | "slate" | "white";

interface InlineSpinnerProps {
  tone?: InlineSpinnerTone;
  className?: string;
}

const TONE_CLASSES: Record<InlineSpinnerTone, string> = {
  brand: "border-brand-200 border-t-brand-700",
  slate: "border-slate-300 border-t-slate-700",
  white: "border-white/40 border-t-white",
};

export function InlineSpinner({ tone = "brand", className = "" }: InlineSpinnerProps) {
  return (
    <span
      aria-hidden="true"
      data-testid="inline-spinner"
      className={`inline-block h-3 w-3 animate-spin rounded-full border ${TONE_CLASSES[tone]} ${className}`.trim()}
    />
  );
}
